import { NewsDetailsPageState } from '../../interfaces/NewsDetailsPageState';

const newsDetailsPageReducer = (state: NewsDetailsPageState): NewsDetailsPageState => state;

export default newsDetailsPageReducer;
